import * as _ from "lodash";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { profileRouterService } from "../../services/profile-router.service";

export const readProfileRouterByProfileId = createAsyncThunk(
  "profileRouterManage/readProfileRouterByProfileId",
  async (profileId, { rejectWithValue }) => {
    try {
      const response = await profileRouterService.readProfileRouterByProfileId(
        profileId
      );

      return _.get(response, "data", {});
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const addProfileRouter = createAsyncThunk(
  "profileRouterManage/addProfileRouter",
  async (data, { rejectWithValue }) => {
    try {
      const response = await profileRouterService.addProfileRouter(data);

      return _.get(response, "data", {});
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const editProfileRouter = createAsyncThunk(
  "profileRouterManage/editProfileRouter",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await profileRouterService.editProfileRouter(id, data);

      return _.get(response, "data", {});
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const removeProfileRouter = createAsyncThunk(
  "profileRouterManage/removeProfileRouter",
  async (id, { rejectWithValue }) => {
    try {
      const response = await profileRouterService.removeProfileRouter(id);

      return _.get(response, "data", {});
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
